import React from 'react';
import './TransactionDetails.css';

const TransactionDetails = () => {
  return (
    <div className="content-box animated">
      <h3>Transaction Details</h3>
      <p>Detailed view of individual transactions.</p>
      <div className="transaction-detail">
        <p><strong>Transaction ID:</strong> TXN123456789</p>
        <p><strong>User:</strong> John Doe</p>
        <p><strong>Amount:</strong> $49.99</p>
        <p><strong>Status:</strong> Completed</p>
        <p><strong>Date:</strong> 2024-10-01</p>
      </div>
    </div>
  );
};

export default TransactionDetails;
